export const stages = [
  {
    id: 1,
    name: "Initial inspection, gas checks and base weights",
  },
  {
    id: 2,
    name: "Hydro date and actual cylinder weight",
  },
  {
    id: 3,
    name: "Valve dismantling and inversion",
  },
  {
    id: 4,
    name: "Slug and water inspection with cleaning",
  },
  {
    id: 5,
    name: "Rejected valve and tare weight validation",
  },
  {
    id: 6,
    name: "Hydrotesting execution",
  },
  {
    id: 7,
    name: "Sand blasting, painting and valve fitting",
  },
  {
    id: 8,
    name: "Vacuum, filling, checks and dispatch",
  },
];
